import Component from 'vue-class-component'
import { Vue, Prop } from 'vue-property-decorator'

@Component
export default class ConfirmDialog extends Vue {
  public dialog = false
  // Props for title and message
  @Prop()
  public title!: string
  @Prop()
  public message!: string

  public context!: any

  public open(context: any) {
    this.context = context
    this.dialog = true
  }

  public accept() {
    this.dialog = false
    this.$emit('confirm', this.context)
  }

  public close() {
    this.dialog = false
  }
}
